import resource from '../resource';

export const bulkUserCreate = resource('/bulk-user-create');
export const bulkUserCreateTemplate = resource('/bulk-user-create-template');
